<th-edit-profile [editAuthenticatedUser]="true"></th-edit-profile>
